import moment from 'moment';
import { browserHistory } from 'react-router';
import {
  call,
  fork,
  select,
  put,
  takeLatest
} from 'redux-saga/effects';
//import { delay } from 'redux-saga';
import loader from '../../../../../util/loader/loader';
import dataProvider from '../../../../../util/dataProvider/dataProvider';
import {
  navigationRoutes,
  navigationSteps,
  //buyFlowUrls
} from '../../../navigation/navigationHelpers';
import {
  LOAD_CONTENT
} from './cancel';
import {
  SET_DATA
} from '../review/review';

/*import {
  productNameSelector,
  setQuickCheckoutData
 } from '../../../data/quickCheckout/quickCheckout';*/
//import {NORMALIZE_DATA} from '../../../dataProvider/dataProvider';
import {
  errorPageByFlow
  //hideGlobalSpinner
} from '../../../common/common';

/*import {
  shoppingElementIdSelector,
  priceReferenceIdSelector,
  setData,
  setProductId
} from '../../../data/checkout/checkout';*/

// WATCHERS
export function* loadContentWatch() {
  yield takeLatest(LOAD_CONTENT, loadContentWorker);
}

/*export function* normalizeWatch() {
  yield takeLatest(NORMALIZE_DATA, normalizeWorker);
}*/

// WORKERS
export function* loadContentWorker() {
  try {
    const buyflowConsumerType = 'CancelStreamingVideo';
    const errorPage = yield select(errorPageByFlow);
    const defaultOfferData = {buyflowConsumerType};
    const addDefaultOfferEndpoint = navigationRoutes[navigationSteps.myPlan.OFFERS].endpoints.addDefaultOfferToCart();
    const confirmCartEndPoint = navigationRoutes[navigationSteps.myPlan.CANCEL].endpoints.confirmCart();
    const myPlanReviewEndpoint = navigationRoutes[navigationSteps.myPlan.REVIEW].endpoints.reviewCart();

    const success = yield call(dataProvider.load, [
      {state: 'auth'},
      {state: 'customer'},
      {state: 'checkEligibility', param: buyflowConsumerType},
      {state: 'offers', param: ''}
    ], {errorPage});

    if (!success) {
      return;
    }

    yield call(loader.request, addDefaultOfferEndpoint, {data: defaultOfferData, useGlobalSpinner: false});
    yield call(loader.request, confirmCartEndPoint, {data: defaultOfferData, useGlobalSpinner: false});
    const reviewData = yield call(loader.request, myPlanReviewEndpoint, {data: defaultOfferData, useGlobalSpinner: false});

    // mimic dataProvider set action to populate the data ahead of the review page
    // could be refactored to use the dataProvider itself but then it might make sense to bring the other 2 calls in as well
    yield put({
      type: SET_DATA,
      payload: {
        loaded: true,
        persistExpiresAt: moment().add(20, 'minute').toDate(),
        content: {
          review: {
            ...reviewData.review,
            flowType: reviewData.flowType
          },
          consentCart: reviewData.consentCart
        }
      }
    });

    browserHistory.replace(`${navigationRoutes[navigationSteps.myPlan.REVIEW].path}`);
  } catch(e) {
    //console.log(e)
  }
}

/*export function* normalizeWorker({key, data, meta}) {
  if (key !== 'productMapping' && key !== 'productForQuickcheckout' && key !== 'customerLobAndProduct') {
    return;
  }

  if (key === 'productMapping') {
    yield put(setData({
      ...meta,
      content: data
    }));
    yield put(setQuickCheckoutData({
      productId: data.shoppingElementId,
      productName: data.productName
    }));
  } else {
    yield put(setProductId(data.priceReferenceId));
  }
}*/

export default function* cancelSagas() {
  yield [
    fork(loadContentWatch)
    //fork(normalizeWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/MyPlan/cancel/cancelSagas.js
 **/